// The Corporate wellness dashboard's sample company, from the dashboard's
// rebuild spec (Corporate Wellness Demo Spec, 5 Oct 2026, section 4.2). Every
// name and number is invented; totals add up across every cut. Wording follows
// the live dashboard ("employees", Low Risk / Monitor / High Risk).

export const COMPANY = { name: "Acme Corp", batch: "Jun 2026", tested: 1200, scored: 1164, repeat: 96, index: 71 };

// CWS tiers: Low Risk 70–100, Monitor 50–69, High Risk 0–49.
export const TIERS = [
  { key: "low", name: "Low Risk", range: "Score 70–100", pct: 58.4, count: 680 },
  { key: "mon", name: "Monitor", range: "Score 50–69", pct: 25.8, count: 300 },
  { key: "high", name: "High Risk", range: "Score 0–49", pct: 15.8, count: 184 },
];

export const RISKS = [
  { name: "Vitamin D", pct: 56, tested: 1050 },
  { name: "Vitamin B12", pct: 33, tested: 1020 },
];

// Top abnormal tests (share of tested employees out of range).
export const TESTS = [
  ["Vitamin D", 56], ["Vitamin B12", 33], ["LDL Cholesterol", 29], ["Triglycerides", 26], ["HbA1c", 21],
];

export const AGES = [
  { name: "Under 35", count: 520, avg: 74, high: 10.7 },
  { name: "Age 35–45", count: 400, avg: 71, high: 15.5 },
  { name: "Over 45", count: 280, avg: 66, high: 25.7 },
];

// [name, average score, employees, low, monitor, high] (scored employees per tier)
export const DEPARTMENTS = [
  ["HR & Support", 79, 130, 90, 28, 8], ["Finance & Admin", 76, 150, 100, 32, 14], ["Engineering", 73, 300, 180, 72, 40],
  ["Sales", 71, 200, 110, 52, 32], ["Operations", 66, 420, 200, 116, 90],
];
export const LOCATIONS = [
  ["Head Office", 77, 270, 180, 57, 25], ["Regional Office", 74, 150, 105, 31, 10],
  ["Plant B", 70, 300, 165, 80, 45], ["Plant A", 67, 480, 230, 132, 104],
];

export const AI = {
  summary: "Health index 71. Vitamin D is the largest risk: low in 56% of those tested.",
  champions: "Head Office leads: average 77, only 10% high risk.",
  watch: "Plant A: 22% high risk, the highest of any site.",
  cohorts: [
    ["Operations", "Dept", "22% high risk, led by LDL and triglycerides."],
    ["Over 45", "Age", "Lowest average score (66), led by HbA1c."],
  ],
};
